import {getData} from "./util";
import {Tool} from "../Config/Tool";
import {convertDate} from "./global";
import {history} from '../history'
import {observableStore} from "./obvStore";

function fmt(d) {
    const o = {};
    Object.keys(d).forEach(k => {
        d[k].forEach(({id, name}) => {
            o[id] = name;
        });
    });
    return o;
}

export const gamesStore = observableStore('_gm',{
    getGameNameByKey(key) {
        const all_games = this.lotteries;
        for (let i = 0, len = all_games.length; i < len; i++) {
            if (all_games[i].chooseId + '' === key + '') {
                return all_games[i].cnName
            }
        }
    },
    getClassNameByKey(key) {
        const all_games = this.lotteries;
        for (let i = 0, len = all_games.length; i < len; i++) {
            if (all_games[i].chooseId + '' === key + '') {
                return all_games[i].iconClassName
            }
        }
    },
    games: {},
    loading: false,
    lotteries: [],
    load() {
        if(this.loading)return ;
        this.loading = true;
        getData('@getLottery',
            undefined,
            (data) => {
                this.loading = false;
                if (data) {
                    this.lotteries.clear();
                    Object.keys(data).forEach(k => data[k].forEach(({id, series_id, name, identifier}) => {
                        this.lotteries.push({
                            chooseId: id,
                            game_name_en: identifier,
                            cnName: name,
                            series_id,
                            iconClassName: {
                                2: "icon115",
                                3: "icon3d",
                                13: "iconp35",
                                19: "iconpk10",
                                15: "iconk3",
                                1: "iconssc",
                            }[series_id]
                        })
                    }))
                    this.games = fmt(data);
                }
            }, () => {
                this.loading = false;
            })
    }
});

export const tranTypeStore = observableStore('_tr', {
    t: 0,
    data: [],
    get types(){
        return [{
            name: '所有类型',
            type_id: '',
        }].concat(this.data.map(({name,id}) => ( {
            name,
            type_id: id,
        })))
    },
    load() {
        getData('@getTransType')
    },
});

const f = a => a - a % 3600000 * 24;
const rec = {
    checkedType: {
        0: 99,
        1: 99
    },
    endTime: f(Date.now() + 3600000 * 24),
    startTime: f(Date.now() - 3600000 * 24 * 14),
    latest: {},
    traceData: {},
    transData: {},
    chargeData: {},
    withdrawalData: {},
    orderData: {},
    loading: false,
    xLoading: false,
    drop(id, cb) {
        this.loading = true;
        getData('@/reports/project-drop', {id},
            ({error, data, msg} = {}) => {
                this.loading = false;
                Tool.alert('撤单成功', () => {
                    history.replace('/game_history?2')
                });
                if ('function' === typeof cb) {
                    cb();
                }
                this.loadLatest();
            },
            ({message, data: {error, data, msg} = {}}) => {
                this.loading = false;
                Tool.alert(error || data || msg || ('撤单失败' + (message && message || '')));
            }, 'POST')
    },
    cancelTrace(id, detailId, cb) {
        this.xLoading = detailId;
        getData('@/reports/trace-detail-cancel', {id, detail_id: detailId},
            ({error, data, msg} = {}) => {
                this.loading = false;
                Tool.alert('取消成功');
                if ('function' === typeof cb) {
                    cb();
                }
                this.loadLatest();
            },
            ({message, data: {error, data, msg} = {}}) => {
                this.xLoading = false;
                Tool.alert(error || data || msg || ('取消失败' + (message && message || '')));
            }, 'POST')
    },
    loadLatest(cb) {
        const {latest} = this;
        if (!Object.keys(latest).length) return;
        this.load({...latest, hard: true}, cb);
    },
    load({gameCur, page, bet_type, found_type, hard = false}, cb) {
        const checkedType = this.checkedType[bet_type];
        const {startTime, endTime} = this;
        this.latest = {startTime, endTime, gameCur, page, bet_type, found_type, checkedType};
        const url = ((found_type && ['', '@/reports/transaction', '@/reports/deposit', '@/reports/withdrawal'][found_type])
            || (bet_type ? '@/reports/trace' : '@/reports/project')) +
            '?start=' + fmt1(startTime, '00:00:00', !found_type) +
            '&end=' + fmt1(endTime, '23:59:59', !found_type) +
            (bet_type !== undefined && checkedType !== undefined ? (+checkedType === 99 ? '' : '&status=' + checkedType) : '') +
            (bet_type !== undefined && gameCur !== undefined && gameCur !== -1 && ('&lottery_id=' + gameCur) || '') +
            (gameCur !== undefined && (gameCur === -1 ? '' : (+gameCur === -1 ? '' : (bet_type !== undefined ? '' : ('&type_id=' + gameCur)))) || '') +
            ('&page=' + page) +
            '&page_size=20';
        const d = found_type ? ['', this.transData, this.chargeData, this.withdrawalData] : (bet_type ? this.traceData : this.orderData);
        const dd = d[url];
        if (!hard && dd) {
            if (dd.t + 1e3 * 30 > Date.now())
                return cb && cb(dd.d);
        }
        this.loading = true;
        getData(url, undefined, data => {
            this.loading = false;
            d[url] = {t: Date.now(), d: data};
            cb && cb(data);
        }, ({data = {}, message}) => {
            this.loading = false;
            //请求失败
            Tool.alert(data.error || message || '');
        })
    }
};
function fmt1(t, a, fmt2) {
    return convertDate(t, fmt2 ? 'YYYY-MM-DD hh:mm:ss' : ('YYYY-MM-DD ' + a));
}
export const recordStore = observableStore('_rec',rec);

